import React from 'react'

import OwnerTotalPropertiesCard from '../Owners/OwnerTotalPropertiesCard'
import OwnerExpectedIncomeCard from '../Owners/OwnerExpectedIncomeCard'
import OwnerPMFeeChargesCard from '../Owners/OwnerPMFeeChargesCard'
import CalendarWidget from '../Calendar/CalendarWiget'
import OwnerPayoutHistoryWidget from '../Owner/OwnerPayoutHistoryWidget'

export default class OwnerDashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="dashboard">
                <div class="row">
                    <OwnerExpectedIncomeCard />
                    {/* <OwnerPMFeeChargesCard /> */}
                    <OwnerTotalPropertiesCard />
                </div>
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <OwnerPayoutHistoryWidget />
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <CalendarWidget />
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Dashboards/OwnerDashboard.jsx